<template>
  <div id="WarehouseTabContent" class="col-md-12 warehouseShippingContent">
    <div class="col-md-4 col-sm-4 pull-left p-0">
      <label class="defaultWarehouseShippingLabel">
        {{ getContentItem("defaultShipViaWarehouse") }}:
      </label>
    </div>
    <div class="col-md-8 col-sm-8 pull-right">
      <v-select
        id="defaultShippingVSelect"
        v-model="defaultShipping"
        class="defaultWarehouseShipping vSelectDropDownText defaultWarehouseShippingText-noWrap"
        :options="DefaultWarehouseShipping"
        :select-on-tab="true"
        @input="SetDefaultShipping"
      />
    </div>
    <div>
      <ul class="warehouseColumns col-md-12">
        <li v-for="(shipper, warehouseKey) in currentTabContentSummary" :key="warehouseKey">
          <label id="checkboxLabel">
            <input
              id="defaultShippingCheckBox"
              v-model="shipper.IsShown"
              type="checkbox"
              @input="AddDirtyData(shipper)"
            >
            {{ shipper.ShippingMethodCode }} - {{ shipper.ShippingMethodDescription }}
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex"
  import vSelect from "vue-select"

  export default {
    components: {
      vSelect
    },
    props: {
      currentTabContentSummary: {},
      dirtyWarehouseShippingTabContent: {
        type: Object,
        default: () => ({}),
        SelectedWarehouseShippingOptions: {
          type: Array
        },
        ThirdPartyShipping: {
          type: Object
        }
      }
    },
    data: () => ({
      warehouseCode: "",
      defaultShipping: "",
      DefaultWarehouseShipping: [{}]
    }),
    computed: {
      ...mapGetters(["user", "getContentItem"])
    },
    watch: {
      currentTabContentSummary: function (val) {
        this.SetDefaultWarehouseShipping()
      }
    },
    methods: {
      SetDefaultWarehouseShipping: function () {
        this.defaultShipping = {}
        let defaultWarehouseShippingList = [{}]
        let summary = this.currentTabContentSummary

        if(!summary){
          return;
        }

        for (let i = 0; i < summary.length; i++) {
          defaultWarehouseShippingList.push({
            label: summary[i].ShippingMethodCode + " - " + summary[i].ShippingMethodDescription,
            value: summary[i].ShippingMethodCode
          })

          if (summary[i].IsDefault) {
            // setting the default shipper if one has been set
            this.defaultShipping = defaultWarehouseShippingList[i + 1]
          }
        }

        // initialization of the array makes the first element blank, this removes it.
        defaultWarehouseShippingList.splice(0, 1)
        this.DefaultWarehouseShipping = defaultWarehouseShippingList
      },
      SetDefaultShipping: function () {
        // Prevent null reference exception, and update data accordingly when default shipping is deleted or set to null
        if (this.defaultShipping === null  && this.currentTabContentSummary) {
          for (let i = 0; i < this.currentTabContentSummary.length; i++) {
            if (this.currentTabContentSummary[i].IsDefault === true) {
              this.currentTabContentSummary[i].IsDefault = false
              this.currentTabContentSummary[i].IsDirtyData = true

              // add dirty data together to update server (method to update in WarehouseShippingOptions.vue)
              this.AddDirtyData(this.currentTabContentSummary[i])
            }
          }
          return
        }

        for (let i = 0; i < this.currentTabContentSummary.length; i++) {
          let currentShipper = this.currentTabContentSummary[i]

          // this prevents setting the default value to dirty upon page load. The rest will update as necessary
          if (this.defaultShipping.value === currentShipper.ShippingMethodCode && currentShipper.IsDefault) {
            break
          } else if (this.defaultShipping.value === currentShipper.ShippingMethodCode && !currentShipper.IsDefault) {
            currentShipper.IsDefault = true
            currentShipper.IsDirtyData = true
            // if current default gets unchecked, this will make sure it is checked in the data and upon reload of page.
            currentShipper.IsShown = true

            // add dirty data together to update server (method to update in WarehouseShippingOptions.vue)
            this.AddDirtyData(currentShipper)
          } else if (currentShipper.IsDefault) {
            // turning previous default off
            currentShipper.IsDefault = false
            currentShipper.IsDirtyData = true

            // add dirty data together to update server (method to update in WarehouseShippingOptions.vue)
            this.AddDirtyData(currentShipper)
          }
        }
      },

      AddDirtyData: function (shipperObject) {
        if (this.dirtyWarehouseShippingTabContent.SelectedWarehouseShippingOptions.length === 0) {
          shipperObject.IsDirtyData = true
          this.dirtyWarehouseShippingTabContent.SelectedWarehouseShippingOptions.push(shipperObject)
        }

        if (!this.dirtyWarehouseShippingTabContent.SelectedWarehouseShippingOptions.includes(shipperObject)) {
          shipperObject.IsDirtyData = true
          this.dirtyWarehouseShippingTabContent.SelectedWarehouseShippingOptions.push(shipperObject)
        }
      }
    },
  }
</script>


<style lang="scss">
.warehouseColumns {
  column-count: 2;
  column-width: 200px;
  list-style-type: none;
  color: black;
  font-size: 13px;
  padding: 10px 0 0 0;
}

.defaultWarehouseShipping {
  width: 300px;
  white-space: nowrap;
  padding: 10px 0 0 3px;
}

.defaultWarehouseShippingText-noWrap .selected-tag {
  width: 250px;
  overflow: hidden;
  white-space: nowrap;
}


.defaultWarehouseShippingLabel {
  font-size: 13px;
  color: black;
  text-align: right;
  padding-top: 15px;
}
</style>